const messages = require("./src/helpers/messages.js")

exports.onInitialClientRender = () => {
  console.info(messages.generateDeveloperConsoleMessage());
}
